import React from 'react'
import { Box, Typography } from '@mui/material'

export default function AcademicServices() {

  return (
    <Box>
      <Box sx={{display: 'flex', flexDirection: 'row'}}>
        <Typography sx={{ fontSize: '1.1rem', marginRight: '1px' }}>
          <b>Reviewer</b>
        </Typography>
        <Typography sx={{ fontSize: '1rem' }}>
            : NeurIPS (2025), ICLR (2025, 2027), ICML (2024, 2025, 2026), COLM (2026), FMDM@NeurIPS (2023)
        </Typography>
      </Box>
    </Box>
  )
}